module.exports = __webpack_public_path__ + "img/t2-endorsement-list.3fd2cad0.png";